import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { AppError } from '../entities/app-error';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private _errors: AppError[] = [];

  constructor(
    private toastrService: ToastrService
  ) {}

  /**
   * Gets errors
   * @returns errors array
   */
  public getErrors(): any[] {
    return this._errors;
  }

  /**
   * Removes an error from index
   * @param index
   * @returns this
   */
  public removeError(index: number): this {
    this._errors.splice(index, 1);

    return this;
  }

  /**
   * Adds an error in array
   * @param error
   * @param title
   * @returns this
   */
  public addError(error: any, title = ''): this {
    this._errors.push({
      title: title ?? 'ERROR.TITLE',
      message:
        error instanceof HttpErrorResponse ? error.error.status.message : error,
    });

    return this;
  }

  /**
   * Shows errors using toastr
   */
  public show(): void {
    this._errors.forEach((error) => {
      this.toastrService.error(error.message, error.title);
    });
    this.clear();
  }

  /**
   * Clears errors' array
   */
  public clear(): void {
    this._errors = [];
  }
}
